import React from "react";
import { Layout } from "components";
import { useNavigate } from "react-router-dom";
import { HomeButton } from "components/CommonUI";

export default function NoAppointment() {
  const navigate = useNavigate();

  return (
    <Layout subHeader={"How can we help?"} mainText={"Your Appointment"}>
      <div className="form-box">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <i class="icon-dls-warning-outline icon-big"></i>

          <div className="center fw-bold text-secondary mt-3">
            <h4 className="title__sub_section">
              You do not have an appointment with us.
            </h4>
          </div>
        </div>

        <div className="form-footer">
          <HomeButton text="Back" />
        </div>
      </div>
    </Layout>
  );
}
